import React from "react";

// ✅ Import images
import banner1 from "../../Assets/8th_slider/1aa229a7ba5-gvrgvgrfvrfvw.png";
import banner2 from "../../Assets/8th_slider/7c5efa3f228-dfdss.png";
import banner3 from "../../Assets/8th_slider/89e1c684ef6-BOGO-PHARMA-DIAG.png";
import EssentialsOfWeek from "./EssentialsOfWeek";

const FrequentlyBooked = () => {
    const banners = [banner1, banner2, banner3];

    return (

        <>
            <section className="w-full bg-white py-10 sm:py-14">
                <div className="max-w-7xl mx-auto px-4 sm:px-6">

                    {/* Heading */}
                    <h2 className="text-2xl sm:text-3xl font-medium text-black mb-6 sm:mb-10">
                        Frequently Booked Health Insurance
                    </h2>

                    {/* Responsive Banner Grid */}
                    <div
                        className="
            grid
            grid-cols-1
            sm:grid-cols-2
            lg:grid-cols-3
            gap-4
            sm:gap-6
          "
                    >
                        {banners.map((img, index) => (
                            <div
                                key={index}
                                className="
                h-[150px]
                sm:h-[160px]
                rounded-[15px]
                overflow-hidden
                shadow-sm
                hover:shadow-lg
                transition
                cursor-pointer
              "
                            >
                                <img
                                    src={img}
                                    alt={`health-banner-${index}`}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        ))}
                    </div>

                </div>
            </section>
            <EssentialsOfWeek />
        </>
    );
};

export default FrequentlyBooked;
